module.exports = __webpack_public_path__ + "static/media/garden trail.5c499311.webp";